<script>
  import { apiFetch } from "../lib/api.js";
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import CardContent from "../components/CardContent.svelte"
  import Modal from "../components/Modal.svelte"
  import Navbar from "../components/Navbar.svelte"
  import Spinner from "../components/Spinner.svelte"
  import UsuarioIndex from "../components/usuario/UsuarioIndex.svelte"
  import { user } from "../stores/user"
  import { BASE_URL } from "../stores/BASE_URL"
  import Alert from "../components/Alert.svelte"
  import Mover from "../components/usuario/Mover.svelte"
  import Sesiones from "../components/usuario/Sesiones.svelte"
  import CambiarPlan from "../components/usuario/CambiarPlan.svelte"

  let usuarios_activos = undefined

  let clientes = []
  let usuarios = []
  let cliente = ""

  let usuario = ""
  let isLoading = false
  let isLoadingUsuario = false

  let documento = ""
  let isLoadingDocumento = false

  let isSuspender = false
  let isActivar = false
  let isBaja = false
  let isCambioClaveObligatorio = false
  let isSolicitarCaptcha = false

  let estado = {
    activo: true,
    suspendido: false,
    de_baja: false,
  }

  let acciones = false

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 3000,
  }

  let modal_usuario = {
    id_usuario: undefined,
    is_open: false,
  }

  let modal_usuario_mover = {
    id_usuario: undefined,
    id_cliente: undefined,
    nombres: "",
    razon_social: "",
    is_open: false,
  }

  let modal_usuario_sesion = {
    id_usuario: undefined,
    nombres: "",
    is_open: false,
  }

  let modal_solicitar_actualizacion_clave = {
    is_open: false,
    cliente: "0",
    usuario: "0",
  }

  let modal_solicitar_captcha = {
    is_open: false,
    id_usuario: "0",
  }

  let modal_cambiar_plan = {
    is_open: false,
    id_usuario: undefined,
  }

  let captcha_usuarios = []
  let clave_usuarios = []

  const getClientes = async () => {
    const response = await apiFetch(`${BASE_URL}cliente.php?action=getClientes`)
    const resp = await response.json()
    clientes = resp.data
  }

  const getUsuarios = async () => {
    const s_cliente = clienteByRazonSocial(cliente)
    if (!s_cliente) {
      window.alert("Seleccionar cliente")
      return
    }

    isLoading = true
    let estado_activo = "x"
    let estado_suspendido = "x"
    let estado_de_baja = "x"
    if (estado.activo) estado_activo = "1"
    if (estado.suspendido) estado_suspendido = "2"
    if (estado.de_baja) estado_de_baja = "0"
    const response = await apiFetch(
      `${BASE_URL}usuario.php?action=getUsuarios&id_cliente=${s_cliente.id}&estado_activo=${estado_activo}&estado_suspendido=${estado_suspendido}&estado_de_baja=${estado_de_baja}`,
    )
    const resp = await response.json()
    usuarios = resp.data
    isLoading = false

    usuarios_activos = usuarios.filter(
      (usuario) => usuario.estado === "1",
    ).length
  }

  const getUsuarioByUsuario = async () => {
    isLoadingUsuario = true
    const response = await apiFetch(
      `${BASE_URL}usuario.php?action=getUsuarioByUsuario&usuario=${usuario}`,
    )
    const resp = await response.json()
    usuarios = resp.data
    isLoadingUsuario = false

    usuarios_activos = usuarios.filter(
      (usuario) => usuario.estado === "1",
    ).length
  }

  const getUsuarioByDocumento = async () => {
    isLoadingDocumento = true
    const response = await apiFetch(
      `${BASE_URL}usuario.php?action=getUsuarioByDocumento&documento=${documento}`,
    )
    const resp = await response.json()
    usuarios = resp.data
    isLoadingDocumento = false
  }

  const getUsuario = (id) => {
    //navigate(`/usuarios/${id}`, { replace: true })
    modal_usuario.id_usuario = id
    modal_usuario.is_open = true
  }

  const handleMoverUsuario = (id, id_cliente, nombres, razon_social) => {
    modal_usuario_mover.id_usuario = id
    modal_usuario_mover.id_cliente = id_cliente
    modal_usuario_mover.nombres = nombres
    modal_usuario_mover.razon_social = razon_social
    modal_usuario_mover.is_open = true
  }

  const handleSesiones = async (id) => {
    modal_usuario_sesion.id_usuario = id
    modal_usuario_sesion.is_open = true
  }

  const handleAgregar = () => {
    navigate("/usuarios/agregar", { replace: true })
  }

  const handleCargar = () => {
    navigate("/usuarios/cargar", { replace: true })
  }

  const handleClave = () => {
    navigate("/usuarios/claves", { replace: true })
  }

  const handleCambiarClave = (id) => {
    navigate(`/usuarios/claves/${id}`, { replace: true })
  }

  const handleExpulsar = async () => {
    alert.show = false
    if (confirm(`¿Estas seguro que deseas expulsar todos los usuarios?`)) {
      const formData = new FormData()
      formData.append("action", "expulsarUsuarios")
      const response = await apiFetch(
        `${BASE_URL}usuario.php`,
        { method: "POST", body: formData },
      )
      alert.show = true
      alert.message = "Usuarios expulsados"
      alert.status = "success"
    }
  }

  const handleSuspender = async () => {
    const s_cliente = clienteByRazonSocial(cliente)
    if (!s_cliente) {
      window.alert("Seleccionar cliente")
      return
    }
    isSuspender = true
    if (
      confirm(
        `¿Desea suspender los usuarios del cliente: "${s_cliente.razon_social}"?`,
      )
    ) {
      alert.show = false
      const formData = new FormData()
      formData.append("id_cliente", s_cliente.id)
      formData.append("action", "suspenderUsuarios")
      formData.append("session_id_usuario", $user.idUsuario)

      const response = await apiFetch(`${BASE_URL}usuario.php`, {
        method: "POST",
        body: formData,
      })
      const resp = await response.json()
      if (resp.status == "success") {
        getUsuarios()
        alert.show = true
        alert.message = "Usuarios suspendidos"
        alert.status = "success"
      } else {
        alert.show = true
        alert.message = "Error al suspender los usuarios"
        alert.status = "danger"
      }
    }
    isSuspender = false
  }

  const handleActivar = async () => {
    const s_cliente = clienteByRazonSocial(cliente)
    if (!s_cliente) {
      window.alert("Seleccionar cliente")
      return
    }
    isActivar = true
    if (
      confirm(
        `¿Desea activar los usuarios del cliente: "${s_cliente.razon_social}"?`,
      )
    ) {
      alert.show = false
      const formData = new FormData()
      formData.append("id_cliente", s_cliente.id)
      formData.append("action", "activarUsuarios")
      formData.append("session_id_usuario", $user.idUsuario)

      const response = await apiFetch(`${BASE_URL}usuario.php`, {
        method: "POST",
        body: formData,
      })
      const resp = await response.json()
      if (resp.status == "success") {
        getUsuarios()
        alert.show = true
        alert.message = "Usuarios activados"
        alert.status = "success"
      } else {
        alert.show = true
        alert.message = "Error al activar los usuarios"
        alert.status = "danger"
      }
    }
    isActivar = false
  }

  const handleBaja = async () => {
    const s_cliente = clienteByRazonSocial(cliente)
    if (!s_cliente) {
      window.alert("Seleccionar cliente")
      return
    }
    isBaja = true
    if (
      confirm(
        `¿Desea dar de baja los usuarios del cliente: "${s_cliente.razon_social}"?`,
      )
    ) {
      alert.show = false
      const formData = new FormData()
      formData.append("id_cliente", s_cliente.id)
      formData.append("action", "bajaUsuarios")
      formData.append("session_id_usuario", $user.idUsuario)

      const response = await apiFetch(`${BASE_URL}usuario.php`, {
        method: "POST",
        body: formData,
      })
      const resp = await response.json()
      if (resp.status == "success") {
        getUsuarios()
        alert.show = true
        alert.message = "Usuarios dados de baja"
        alert.status = "success"
      } else {
        alert.show = true
        alert.message = "Error al dar de baja los usuarios"
        alert.status = "danger"
      }
    }
    isBaja = false
  }

  const handleActualizacionClaves = () => {
    modal_solicitar_actualizacion_clave.is_open = true
  }

  const handleCaptcha = () => {
    modal_solicitar_captcha.is_open = true
  }

  const getCaptchaUsuarios = async (captcha_id_cliente) => {
    if (captcha_id_cliente == "0") {
      captcha_usuarios = []
      modal_solicitar_captcha.id_usuario = "0"
      return
    }
    const response = await apiFetch(
      `${BASE_URL}/usuario.php?action=getUsuarios&id_cliente=${captcha_id_cliente}&estado_activo=1`,
    )
    const resp = await response.json()
    captcha_usuarios = resp.data
  }

  const getClaveUsuarios = async (clave_id_cliente) => {
    if (clave_id_cliente == "0") {
      clave_usuarios = []
      modal_solicitar_actualizacion_clave.usuario = "0"
      return
    }
    const response = await apiFetch(
      `${BASE_URL}/usuario.php?action=getUsuarios&id_cliente=${clave_id_cliente}&estado_activo=1`,
    )
    const resp = await response.json()
    clave_usuarios = resp.data
  }

  const handleActualizacionClavesEjecutar = async () => {
    isCambioClaveObligatorio = true
    if (
      window.confirm(
        "¿Estás seguro de que deseas solicitar el cambio de claves?",
      )
    ) {
      console.log(
        "Cambio de claves al cliente: " +
          modal_solicitar_actualizacion_clave.cliente,
      )
      const formData = new FormData()
      formData.append("id_cliente", modal_solicitar_actualizacion_clave.cliente)
      formData.append("id_usuario", modal_solicitar_actualizacion_clave.usuario)
      formData.append("action", "atualizacionClaveObligatoria")
      formData.append("session_id_usuario", $user.idUsuario)

      const response = await apiFetch(`${BASE_URL}usuario.php`, {
        method: "POST",
        body: formData,
      })
      const resp = await response.json()
      if (resp.status == "success") {
        if (modal_solicitar_actualizacion_clave.cliente != "0") {
          cliente = razonSocialById(modal_solicitar_actualizacion_clave.cliente)
          getUsuarios()
        }
        alert.show = true
        alert.message = "Se activó el cambio de clave obligatorio"
        alert.status = "success"
      } else {
        alert.show = true
        alert.message = "Error al activar el cambio de clave obligatorio"
        alert.status = "danger"
      }
      modal_solicitar_actualizacion_clave.is_open = false
    } else {
      modal_solicitar_actualizacion_clave.is_open = false
    }
    isCambioClaveObligatorio = false
  }

  const handleSolicitarCaptchaEjecutar = async () => {
    isSolicitarCaptcha = true
    if (window.confirm("¿Estás seguro de que deseas solicitar captcha?")) {
      console.log(
        "Solicitar captcha al cliente: " + modal_solicitar_captcha.id_cliente,
      )
      const formData = new FormData()
      formData.append("id_cliente", modal_solicitar_captcha.id_cliente)
      formData.append("id_usuario", modal_solicitar_captcha.id_usuario)
      formData.append("action", "solicitarCaptcha")
      formData.append("session_id_usuario", $user.idUsuario)

      const response = await apiFetch(`${BASE_URL}usuario.php`, {
        method: "POST",
        body: formData,
      })
      const resp = await response.json()
      if (resp.status == "success") {
        if (modal_solicitar_captcha.id_cliente != "0") {
          cliente = razonSocialById(modal_solicitar_captcha.id_cliente)
          getUsuarios()
        }
        alert.show = true
        alert.message = "Se activó la verficación"
        alert.status = "success"
      } else {
        alert.show = true
        alert.message = "Error al solictar captcha"
        alert.status = "danger"
      }
      modal_solicitar_captcha.is_open = false
    } else {
      modal_solicitar_captcha.is_open = false
    }
    isSolicitarCaptcha = false
  }

  const handleCambiarPlan = (id) => {
    modal_cambiar_plan.is_open = true
    modal_cambiar_plan.id_usuario = id
  }

  function razonSocialById(id) {
    const cliente_ncontrado = clientes.find((c) => c.id == id)
    if (cliente_ncontrado) {
      return cliente_ncontrado.razon_social
    } else {
      return "Cliente no encontrado"
    }
  }

  function clienteByRazonSocial(razon_social) {
    let s_cliente = clientes.find((c) => c.razon_social === razon_social)
    if (s_cliente) {
      return s_cliente
    } else {
      return undefined
    }
  }

  const reloadUsuarios = () => {
    const s_cliente = clienteByRazonSocial(cliente)
    if (s_cliente) {
      getUsuarios()
    } else if (usuario.trim() != "") {
      getUsuarioByUsuario()
    }
  }

  const closedModalCambiarPlan = () => {
    modal_cambiar_plan.is_open = false
    reloadUsuarios()
  }

  getClientes()

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }

    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true
    }
  })
</script>

{#if $user}
  <Navbar />
  <div class="container-fluid py-3">
    <CardContent title="Usuarios">
      <div class="row g-2 align-items-center">
        <div class="col-12 col-sm-12 col-md-6 col-lg-4">
          <input
            list="list_clientes"
            bind:value={cliente}
            class="form-control"
            placeholder="Cliente"
          />
          <datalist id="list_clientes">
            {#each clientes as cliente}
              <option value={cliente.razon_social} />
            {/each}
          </datalist>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-auto">
          <div
            class="btn-group"
            role="group"
            aria-label="Basic checkbox toggle button group"
          >
            <input
              type="checkbox"
              class="btn-check"
              id="btncheck1"
              autocomplete="off"
              checked={estado.activo}
              on:change={() => (estado.activo = !estado.activo)}
            />
            <label class="btn btn-sm btn-outline-success" for="btncheck1">
              Activo
            </label>
            <input
              type="checkbox"
              class="btn-check"
              id="btncheck2"
              autocomplete="off"
              checked={estado.suspendido}
              on:change={() => (estado.suspendido = !estado.suspendido)}
            />
            <label class="btn btn-sm btn-outline-danger" for="btncheck2">
              Suspendido
            </label>
            <input
              type="checkbox"
              class="btn-check"
              id="btncheck3"
              autocomplete="off"
              checked={estado.de_baja}
              on:change={() => (estado.de_baja = !estado.de_baja)}
            />
            <label class="btn btn-sm btn-outline-dark" for="btncheck3"
              >De baja</label
            >
          </div>
          {#if isLoading}
            <button class="btn btn-primary" type="button" disabled>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Cargando...
            </button>
          {:else}
            <button class="btn btn-primary" on:click={getUsuarios}>
              <i class="bi bi-search" /> Buscar
            </button>
          {/if}
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-auto">
          <div class="btn-group" role="group">
            {#if isSuspender}
              <button class="btn btn-danger" type="button" disabled>
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Suspendiendo...
              </button>
            {:else}
              <button
                type="button"
                class="btn btn-danger"
                on:click={handleSuspender}
              >
                <i class="bi bi-person-fill-slash" />
                Suspender usuarios
              </button>
            {/if}
            {#if isActivar}
              <button class="btn btn-success" type="button" disabled>
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Activando...
              </button>
            {:else}
              <button
                type="button"
                class="btn btn-success"
                on:click={handleActivar}
              >
                <i class="bi bi-person-fill-check"></i>
                Activar usuarios
              </button>
            {/if}
            {#if isBaja}
              <button class="btn btn-dark" type="button" disabled>
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Dando de baja...
              </button>
            {:else}
              <button type="button" class="btn btn-dark" on:click={handleBaja}>
                <i class="bi bi-person-dash-fill"></i>
                Dar de baja
              </button>
            {/if}
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-auto d-flex gap-2">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar por usuario"
              aria-label="Buscar por usuario"
              aria-describedby="button-addon2"
              bind:value={usuario}
            />
            {#if isLoadingUsuario}
              <button
                class="btn btn-primary"
                type="button"
                id="button-addon2"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              </button>
            {:else}
              <button
                class="btn btn-primary"
                type="button"
                id="button-addon2"
                on:click={getUsuarioByUsuario}
              >
                <i class="bi bi-search" />
              </button>
            {/if}
          </div>

          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar por documento"
              aria-label="Buscar por documento"
              aria-describedby="button-addon3"
              bind:value={documento}
            />
            {#if isLoadingDocumento}
              <button
                class="btn btn-primary"
                type="button"
                id="button-addon3"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              </button>
            {:else}
              <button
                class="btn btn-primary"
                type="button"
                id="button-addon3"
                on:click={getUsuarioByDocumento}
              >
                <i class="bi bi-search" />
              </button>
            {/if}
          </div>
        </div>
        {#if acciones}
          <div
            class="row g-2 align-items-center mt-2 alert alert-warning pt-1 pb-2"
          >
            <div class="col-auto">
              <button class="btn btn-primary" on:click={handleAgregar}>
                <i class="bi bi-person-plus-fill" /> Agregar
              </button>
            </div>
            <!-- <div class="col-auto">
            <button class="btn btn-primary" on:click={handleCargar}>
              <i class="bi bi-people-fill" /> Cargar
            </button>
          </div> -->
            <div class="col-auto">
              <button class="btn btn-warning" on:click={handleClave}>
                <i class="bi bi-pencil-square" /> Cambiar contraseñas
              </button>
            </div>
            <div class="col-auto">
              <button
                class="btn btn-warning"
                on:click={handleActualizacionClaves}
              >
                <i class="bi bi-lock-fill" /> Solicitar actualización de contraseña
              </button>
            </div>
            <div class="col-auto">
              <button class="btn btn-warning" on:click={handleCaptcha}>
                <i class="bi bi-check2-circle"></i> Solicitar captcha
              </button>
            </div>
            <div class="col-auto">
              <button class="btn btn-dark" on:click={handleExpulsar}>
                <i class="bi bi-person-x-fill" /> Expulsar todos los usuarios
              </button>
            </div>
            <div class="col text-end">
              {#if usuarios_activos}
                <p>
                  Usuarios activos:
                  <b>
                    {Number(usuarios_activos).toLocaleString("es-PE")}
                  </b>
                </p>
              {/if}
            </div>
          </div>
        {/if}

        {#if alert.show}
          <Alert
            message={alert.message}
            status={alert.status}
            time={alert.time}
          />
        {/if}

        <div class="table-responsive mt-3 table-responsive-200">
          <table class="table table-sm table-striped table-bordered small">
            <thead>
              <tr class="text-secondary fw-normal">
                <th>Usuario</th>
                <th>Tipo Doc.</th>
                <th>Num. Doc.</th>
                <th>Nombres</th>
                <th>Empresa</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Consultas</th>
                <th>Consumo</th>
                <th>Plan</th>
                <th>Masivos</th>
                <th>Celular</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody id="usuarios">
              {#if isLoading || isLoadingUsuario}
                <tr>
                  <td colspan="14">
                    <Spinner message="Cargando" />
                  </td>
                </tr>
              {:else}
                {#each usuarios as usuario}
                  <tr>
                    <td>{usuario.usuario}</td>
                    <td>{usuario.tipo_documento}</td>
                    <td>{usuario.documento}</td>
                    <td>{usuario.nombres}</td>
                    <td class="razon_social">{usuario.razon_social}</td>
                    <td>{usuario.inicio}</td>
                    <td>{usuario.fin}</td>
                    <td class="text-end"
                      >{Number(usuario.consultas).toLocaleString("es-PE")}</td
                    >
                    <td class="text-end"
                      >{Number(usuario.consumo).toLocaleString("es-PE")}</td
                    >
                    <td>{usuario.plan}</td>
                    <td class="text-end"
                      >{Number(usuario.consultas_masivas).toLocaleString(
                        "es-PE",
                      )}</td
                    >
                    <td>
                      {#if usuario.celular !== ""}
                        {usuario.celular_codigo}
                        {usuario.celular}
                      {/if}
                    </td>
                    <td>
                      {#if usuario.estado == "1"}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                        >
                          Activo
                        </small>
                      {:else if usuario.estado == "2"}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                        >
                          Suspendido
                        </small>
                      {:else}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-dark bg-dark bg-opacity-10 border border-dark border-opacity-10 rounded-2"
                        >
                          De baja
                        </small>
                      {/if}

                      {#if usuario.actualizar_clave == "1"}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                        >
                          <i class="bi bi-unlock-fill"></i>
                        </small>
                      {:else}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                        >
                          <i class="bi bi-lock-fill"></i>
                        </small>
                      {/if}

                      {#if usuario.verificar == "1"}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-warning bg-warning bg-opacity-10 border border-warning border-opacity-10 rounded-2"
                        >
                          <i class="bi bi-exclamation-lg"></i>
                        </small>
                      {/if}
                    </td>
                    <td class="fit-content">
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-sm btn-light dropdown-toggle py-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Acciones
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <button
                              class="dropdown-item btn btn-sm btn-primary"
                              type="button"
                              on:click={() => getUsuario(usuario.id)}
                            >
                              <i class="bi bi-eye text-primary"></i>
                              <span class="small">Ver</span>
                            </button>
                          </li>
                          <li>
                            <button
                              class="dropdown-item btn btn-sm btn-warning"
                              type="button"
                              on:click={handleCambiarClave(usuario.id)}
                            >
                              <i class="bi bi-pencil-square text-warning" />
                              <span class="small">Cambiar contraseña</span>
                            </button>
                          </li>
                          <li>
                            <button
                              class="dropdown-item btn btn-sm btn-secondary"
                              type="button"
                              on:click={handleMoverUsuario(
                                usuario.id,
                                usuario.id_cliente,
                                usuario.nombres,
                                usuario.razon_social,
                              )}
                            >
                              <i class="bi bi-arrow-up-right-square"></i>
                              <span class="small">Mover</span>
                            </button>
                          </li>
                          <li>
                            <button
                              class="dropdown-item btn btn-sm btn-warning"
                              type="button"
                              on:click={handleSesiones(usuario.id)}
                            >
                              <i class="bi bi-key text-warning"></i>
                              <span class="small">Inicio de sesión</span>
                            </button>
                          </li>
                          <li>
                            <button
                              class="dropdown-item btn btn-sm btn-warning"
                              type="button"
                              on:click={handleCambiarPlan(usuario.id)}
                            >
                              <i class="bi bi-arrow-down-up text-success"></i>
                              <span class="small">Cambiar plan</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                {:else}
                  <tr>
                    <td colspan="14" class="text-center text-secondary">
                      · · · No se encontraron resultados · · ·
                    </td>
                  </tr>
                {/each}
              {/if}
            </tbody>
          </table>
        </div>
      </div></CardContent
    >

    <Modal isOpen={modal_usuario.is_open}>
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              on:click={() => {
                modal_usuario.is_open = false
                reloadUsuarios()
              }}
            />
          </div>
          <div class="modal-body bg-light">
            {#if modal_usuario.id_usuario !== undefined}
              <div class="container-fluid py-2">
                <UsuarioIndex id={modal_usuario.id_usuario} />
              </div>
            {/if}
          </div>
        </div>
      </div>
    </Modal>

    <Modal isOpen={modal_usuario_mover.is_open}>
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              on:click={() => {
                modal_usuario_mover.is_open = false
                reloadUsuarios()
              }}
            />
          </div>
          <div class="modal-body bg-light">
            {#if modal_usuario_mover.id_usuario !== undefined}
              <div class="container-fluid py-2">
                <Mover
                  id={modal_usuario_mover.id_usuario}
                  id_cliente={modal_usuario_mover.id_cliente}
                  nombres={modal_usuario_mover.nombres}
                  razon_social={modal_usuario_mover.razon_social}
                  {clientes}
                />
              </div>
            {/if}
          </div>
        </div>
      </div>
    </Modal>

    <Modal isOpen={modal_usuario_sesion.is_open}>
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              on:click={() => {
                modal_usuario_sesion.is_open = false
              }}
            />
          </div>
          <div class="modal-body bg-light">
            {#if modal_usuario_sesion.id_usuario !== undefined}
              <div class="container-fluid py-2">
                <Sesiones
                  id={modal_usuario_sesion.id_usuario}
                  id_cliente={modal_usuario_sesion.id_cliente}
                  nombres={modal_usuario_sesion.nombres}
                  razon_social={modal_usuario_sesion.razon_social}
                />
              </div>
            {/if}
          </div>
        </div>
      </div>
    </Modal>

    <Modal isOpen={modal_solicitar_actualizacion_clave.is_open}>
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Solicitar actualización de contraseña</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              on:click={() => {
                modal_solicitar_actualizacion_clave.is_open = false
              }}
            />
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-lg-8">
                <label class="form-label">
                  Seleccionar un Cliente o "TODOS" para solicitar el cambio de
                  clave obligatorio:
                  <select
                    class="form-select mt-1"
                    bind:value={modal_solicitar_actualizacion_clave.cliente}
                    on:change={() =>
                      getClaveUsuarios(
                        modal_solicitar_actualizacion_clave.cliente,
                      )}
                  >
                    <option value="0">TODOS</option>
                    {#each clientes as cliente}
                      <option value={cliente.id}>{cliente.razon_social}</option>
                    {/each}
                  </select>
                </label>
              </div>
              <div class="col-12 col-lg-4">
                <label class="form-label w-100">
                  Usuario:
                  <select
                    class="form-select mt-1"
                    bind:value={modal_solicitar_actualizacion_clave.usuario}
                  >
                    <option value="0">TODOS</option>
                    {#each clave_usuarios as usuario}
                      <option value={usuario.id}
                        >{usuario.usuario} - {usuario.nombres}</option
                      >
                    {/each}
                  </select>
                </label>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              on:click={() =>
                (modal_solicitar_actualizacion_clave.is_open = false)}
              >Cancelar</button
            >
            {#if isCambioClaveObligatorio}
              <button class="btn btn-danger mt-2" disabled
                >Solicitar actualización...</button
              >
            {:else}
              <button
                class="btn btn-danger mt-2"
                on:click={handleActualizacionClavesEjecutar}
                >Solicitar actualización</button
              >
            {/if}
          </div>
        </div>
      </div>
    </Modal>

    <Modal isOpen={modal_solicitar_captcha.is_open}>
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Solicitar captcha</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              on:click={() => {
                modal_solicitar_captcha.is_open = false
              }}
            />
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-lg-8">
                <label class="form-label">
                  Seleccionar un Cliente o "TODOS" para solicitar captcha:
                  <select
                    class="form-select mt-1"
                    bind:value={modal_solicitar_captcha.id_cliente}
                    on:change={() =>
                      getCaptchaUsuarios(modal_solicitar_captcha.id_cliente)}
                  >
                    <option value="0">TODOS</option>
                    {#each clientes as cliente}
                      <option value={cliente.id}>{cliente.razon_social}</option>
                    {/each}
                  </select>
                </label>
              </div>
              <div class="col-12 col-lg-4">
                <label class="form-label w-100">
                  Usuario:
                  <select
                    class="form-select mt-1"
                    bind:value={modal_solicitar_captcha.id_usuario}
                  >
                    <option value="0">TODOS</option>
                    {#each captcha_usuarios as usuario}
                      <option value={usuario.id}
                        >{usuario.usuario} - {usuario.nombres}</option
                      >
                    {/each}
                  </select>
                </label>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              on:click={() => (modal_solicitar_captcha.is_open = false)}
              >Cancelar</button
            >
            {#if isSolicitarCaptcha}
              <button class="btn btn-danger mt-2" disabled
                >Solicitar captcha...</button
              >
            {:else}
              <button
                class="btn btn-danger mt-2"
                on:click={handleSolicitarCaptchaEjecutar}
                >Solicitar captcha</button
              >
            {/if}
          </div>
        </div>
      </div>
    </Modal>

    <Modal isOpen={modal_cambiar_plan.is_open}>
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              on:click={closedModalCambiarPlan}
            />
          </div>
          <div class="modal-body bg-light">
            {#if modal_cambiar_plan.id_usuario !== undefined}
              <div class="container-fluid py-2">
                <CambiarPlan
                  id_usuario={modal_cambiar_plan.id_usuario}
                  on:closed={closedModalCambiarPlan}
                ></CambiarPlan>
              </div>
            {/if}
          </div>
        </div>
      </div>
    </Modal>
  </div>
{/if}

<style>
  .razon_social {
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .fit-content {
    white-space: nowrap; /* Evita que el contenido se divida en múltiples líneas */
    width: 1%; /* Hace que la columna ocupe solo el espacio necesario */
  }

  .table-responsive-200 {
    min-height: 232px;
  }
</style>
